App.directive('guestNavigation', function() {
    return {
        restrict: 'E',
        templateUrl: 'common/views/guestNavigationView.html'
    };
});